import {
    useQuery,
    useMutation,
    useQueryClient,
  } from '@tanstack/react-query'
import api from '../utils/axios'
import { API_ROUTES } from './routes'
import { showToast } from '../components/ui/toast'

export const useUpdateContractorMutation = (options = {}) => {
    const queryClient = useQueryClient()
    const {
        mutate,
        isError,
        error,
        isLoading,
        isSuccess,
        isPending
    } = useMutation(
        {
            mutationFn: (data) => api.put(`${API_ROUTES.UPDATE_CONTRACTOR}/${data?.id}`, data),
            onSuccess: (...args) => {
                showToast('success', 'Contractor updated successfully')
                options.onSuccess?.(...args)
            },
            onSettled: () => {
                queryClient.invalidateQueries(API_ROUTES.GET_CONTRACTORS)
            },

        }
    )
    return { mutate, isError, error, isLoading, isSuccess, isPending }
}

export const useGetContractorByIdQuery = (id) => {
    const { data, isPending, isError, error } = useQuery({
        queryKey:[API_ROUTES.GET_CONTRACTORS, id], 
        queryFn:() => api.get(`${API_ROUTES.GET_CONTRACTORS}/${id}`),
        enabled: !!id,
})

    return {isPending, isError, user:data?.data?.data, error}
}

export const useGetContractorQuery = (params = {}) => {
  return useQuery({
    queryKey: ["contractors", params],
    queryFn: async () => {
      const { data } = await api.get("/admin/contractor", { params });
      return data.data;
    },
  });
};

export const useDeleteContractorMutation = () => {
    const queryClient = useQueryClient()
    const {
        mutate,
        isError,
        error,
        isLoading,
        isSuccess,
        isPending
    } = useMutation(
        {
            mutationFn: (id) => api.delete(`${API_ROUTES.DELETE_CONTRACTOR}/${id}`),
            onSuccess: () => {
                showToast('success', 'Contractor deleted successfully')
            },
            onSettled: () => {
                queryClient.invalidateQueries(API_ROUTES.GET_CONTRACTORS)
            },

        }
    )
    return { mutate, isError, error, isLoading, isSuccess, isPending }
}
